<template>
	<div class="tabs1">
		暂定标签0
	</div>
</template>

<script>
	export default {
		data() {
		  return {
		
		  };
		},
		methods: {
			
		},
	}
</script>

<style lang="less" scoped>
	.tabs1 {
		padding: 0 12px;
	}
</style>